const LabeledInput = () => { return import(/* webpackChunkName: 'labeled-input' */ './LabeledInput.vue'); };

export {
    LabeledInput,
};
